import { c as _c } from "react/compiler-runtime";
import { EmptyState } from '@onefootprint/ui';
import Head from 'next/head';
import Image from 'next/image';
import { useTranslation } from 'react-i18next';
type ErrorProps = {
  resetErrorBoundary: () => void;
};
const ErrorComponent = t0 => {
  const $ = _c(24);
  const {
    resetErrorBoundary
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "error"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("common", t1);
  let t2;
  if ($[1] !== t) {
    t2 = t(_temp);
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <Head><title>{t2}</title></Head>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t(_temp2);
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t) {
    t5 = t(_temp3);
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t(_temp4);
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== resetErrorBoundary || $[12] !== t6) {
    t7 = {
      label: t6,
      onClick: resetErrorBoundary
    };
    $[11] = resetErrorBoundary;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t) {
    t8 = () => <Image alt={t(_temp5)} height={174} src="/404/stamp.png" width={192} priority={true} />;
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t4 || $[17] !== t5 || $[18] !== t7 || $[19] !== t8) {
    t9 = <div className="flex h-dvh md:h-screen w-full items-center justify-center"><div className="mx-auto w-full max-w-7xl px-3 sm:px-4 md:px-6 lg:px-8"><EmptyState title={t4} description={t5} cta={t7} renderHeader={t8} /></div></div>;
    $[16] = t4;
    $[17] = t5;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t3 || $[22] !== t9) {
    t10 = <>{t3}{t9}</>;
    $[21] = t3;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
};
export default ErrorComponent;
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.title;
}
function _temp3($_1) {
  return $_1.description;
}
function _temp4($_2) {
  return $_2.cta;
}
function _temp5($_3) {
  return $_3.image.alt;
}